export const coreValues = [
  {
    title: '1. 국민 상거래 포털',
    desc: (
      <>
        KODEAL은 ‘KO(한국)’와 ‘DEAL(영업/상거래)’의 결합을 통해, 전 국민이
        참여할 수 있는 디지털 상거래 허브를 지향합니다.
        <br />
        소수의 판매자가 아닌, 누구나 신뢰를 바탕으로 거래에 참여하고 성장할 수
        있는 개방형 플랫폼 생태계를 구현합니다.
      </>
    ),
  },
  {
    title: '2. 신뢰 기반 연결',
    desc: (
      <>
        KODEAL은 사람과 사람, 기업과 시장, 소비자와 전문가를 잇는 신뢰의
        브릿지입니다.
        <br />
        단순한 영업 행위를 넘어, 전문성과 진정성으로 연결된 거래 환경을
        만들어갑니다.
      </>
    ),
  },
  {
    title: '3. 전문성 중심의 상생 플랫폼',
    desc: (
      <>
        영업인의 역량이 곧 거래의 질이 되는 시대,
        <br />
        KODEAL은 검증된 전문성과 윤리적 책임을 바탕으로 모두가 함께 성장하는
        구조를 설계합니다. 개인의 성과를 넘어 집단의 상생 가치를 실현합니다.
      </>
    ),
  },
  {
    title: '4. 경제를 움직이는 힘',
    desc: (
      <>
        KODEAL은 대한민국 상거래의 실질적 동력입니다. 소비의 최전선에서 활동하는
        영업인을 통해, 현장의 수요와 변화를 가장 먼저 반영하는 실천형 플랫폼으로
        국내 경제의 활력을 이끌어냅니다.
      </>
    ),
  },
  {
    title: '5. 미래를 연결하는 브릿지',
    desc: (
      <>
        오늘의 신뢰와 내일의 성장을 잇는 다리,
        <br />
        KODEAL은 기술과 사람, 시장과 가치를 연결하는 지속 가능한 상거래 인프라를
        구축합니다. 디지털 전환 속에서도 사람 중심의 가치를 놓치지 않는 새로운
        표준을 제시합니다.
      </>
    ),
  },
];

const CISection = ({
  contentsRef,
}: {
  contentsRef: React.RefObject<HTMLDivElement>;
}) => {
  return (
    <section className='w-full mb-[30px]' ref={contentsRef}>
      <div className='max-w-[1080px] flex flex-col justify-start gap-[30px] items-start px-[20px] pb-[20px] mx-auto relative'>
        <div className='w-full flex flex-col justify-start items-stretch'>
          <div className='flex flex-col justify-start items-start'>
            <h3 className='text-[#2F46B8] text-[14px] leading-[14px] font-[600] mb-[12px]'>
              CI 소개
            </h3>
            <h4 className='text-[16px] leading-[25.6px] font-[600] text-[#1C1F35]'>
              한국영업경제인협회
            </h4>
          </div>
          <div className='w-full mt-[30px]'>
            <ul className='w-full flex flex-col justify-start items-start gap-[10px]'>
              <li className='w-full flex justify-center items-center border border-[#E5E5EC] rounded-[10px] p-[50px]'>
                <img
                  src='/imgs/icons/fks_symbol.png'
                  alt='협회 심볼'
                  className='h-[80px] object-contain'
                />
              </li>
              <li className='w-full flex justify-center items-center border border-[#E5E5EC] rounded-[10px] p-[50px] bg-gradient-to-t from-[#172A88] via-[#036EB8] to-[#008ED2]'>
                <img
                  src='/imgs/icons/fks_symbol_white.png'
                  alt='협회 심볼'
                  className='h-[80px] object-contain'
                />
              </li>
              <li className='w-full flex justify-center items-center border border-[#E5E5EC] rounded-[10px] py-[70px] px-[30px]'>
                <img
                  src='/imgs/icons/fks_logo.png'
                  alt='협회 로고'
                  className='h-[40px] object-contain'
                />
              </li>
              <li className='w-full flex justify-center items-center border border-[#E5E5EC] rounded-[10px] py-[70px] px-[30px] bg-gradient-to-t from-[#172A88] via-[#036EB8] to-[#008ED2]'>
                <img
                  src='/imgs/icons/fks_logo_white.png'
                  alt='협회 로고'
                  className='h-[40px] object-contain'
                />
              </li>
            </ul>
          </div>
          <p className='text-[15px] leading-[160%] font-[500] text-[#222] tracking-[-0.025em] mt-5'>
            대한민국 경제의 최전선에서 활약하는 영업인의 전문성과 사회적 가치를
            확산하고, 지속 가능한 성장과 역량 강화를 체계적으로 지원함으로써,
            영업 직군의 위상을 높이고 국가 경제의 든든한 동반자로 자리매김하기
            위해 설립되었습니다.
          </p>
        </div>
        <div className='w-full flex flex-col justify-between items-stretch gap-4'>
          <div>
            <h4 className='text-[16px] leading-[25.6px] font-[600] text-[#1C1F35]'>
              Core Value
            </h4>
          </div>
          <div className='w-full flex flex-col gap-[6px]'>
            <strong className='text-[#182987] text-[16px] leading-[25.6px] font-[600] tracking-[-0.025em]'>
              ‘마주보는 상승 화살표’와 ‘뫼비우스의 형태’를 기반으로 한 본
              로고는, 대한민국 경제의 중심에서 끊임없이 도약하는 영업인의 신뢰와
              전문성을 상징합니다.
            </strong>
            <p className='text-[15px] leading-[24px] font-[500] text-[#222] tracking-[-0.025em]'>
              상향된 두 개의 화살표는 서로를 향한{' '}
              <strong className='font-bold'>상생과 신뢰</strong>
              를, 동시에 힘차게 상승하는{' '}
              <strong className='font-bold'>성장 에너지</strong>를 표현하며,
              이들이 만나는 구조는 영업인이 고객과 시장, 산업을 연결하는 경제의
              다리(Bridge of Vitality)로서의 역할을 상징합니다.
              <br />이 모든 흐름을 하나로 이어주는 뫼비우스의 띠는{' '}
              <strong className='font-bold'>
                지속 가능한 성장의 흐름과 책임감 있는 전문성의 영속성
              </strong>
              을 형상화하였습니다.
              <br />
              단순한 상징을 넘어,{' '}
              <strong className='font-bold'>
                영업인의 역량 강화와 사회적 가치를 동시에 실현하는 새로운 기준점
              </strong>
              을 제시하는 협회의 비전을 담고 있습니다.
            </p>
          </div>
        </div>
        <div className='w-full flex flex-col justify-start items-stretch gap-[30px]'>
          <div className='flex flex-col justify-start items-start'>
            <h4 className='text-[16px] leading-[25.6px] font-[600] text-[#1C1F35]'>
              Background
            </h4>
          </div>
          <div className='w-full'>
            <ul className='w-full flex flex-col justify-start items-start gap-[10px] mb-[30px]'>
              <li className='w-full flex justify-center items-center border border-[#E5E5EC] overflow-hidden rounded-[10px]'>
                <img
                  src='/imgs/section0_bg02.webp'
                  alt='협회 배경1'
                  className='w-full aspect-[335/180] object-cover'
                />
              </li>
              <li className='w-full flex justify-center items-center border border-[#E5E5EC] overflow-hidden rounded-[10px]'>
                <img
                  src='/imgs/section0_bg01.webp'
                  alt='협회 배경2'
                  className='w-full aspect-[335/180] object-cover'
                />
              </li>
            </ul>
          </div>
        </div>
        <div className='w-full flex flex-col justify-start items-stretch gap-[30px]'>
          <div className='flex flex-col justify-start items-start'>
            <h3 className='text-[#2F46B8] text-[14px] leading-[14px] font-[600] mb-[12px]'>
              CI 소개
            </h3>
            <h4 className='text-[16px] leading-[25.6px] font-[600] text-[#1C1F35]'>
              Kodeal
            </h4>
          </div>
          <div className='w-full'>
            <ul className='w-full flex flex-col justify-start items-start gap-[10px] mb-4'>
              <li className='w-full flex justify-center items-center border border-[#E5E5EC] rounded-[10px] py-[70px] px-[60px]'>
                <img
                  src='/imgs/icons/kodealtalk.png'
                  alt='코딜톡 로고'
                  className='w-[204px] object-contain'
                />
              </li>
              <li className='w-full flex justify-center items-center border border-[#E5E5EC] rounded-[10px] py-[70px] px-[60px]'>
                <img
                  src='/imgs/icons/kodealhub.png'
                  alt='코딜허브 로고'
                  className='w-[204px] object-contain'
                />
              </li>
            </ul>
            <p className='text-[15px] leading-[24px] font-[500] text-[#222] tracking-[-0.025em]'>
              ‘KO(한국)’와 ‘DEAL(영업/상거래)’의 합성어로, 전 국민이 함께하는
              신뢰 기반 상거래 포털을 지향합니다.
              <br />
              대한민국 상거래의{' '}
              <strong className='font-bold'>전문 파트너</strong>이자{' '}
              <strong className='font-bold'>미래를 연결하는 브릿지</strong>
              입니다.
              <br />
              <br />
              ‘KODEAL’은 상생과 성장, 신뢰와 책임이 살아있는{' '}
              <strong className='font-bold'>
                전국민 상거래 생태계를 실현하는 새로운 시작점
              </strong>
              입니다.
            </p>
          </div>
        </div>
        <div className='w-full flex flex-col justify-between items-stretch gap-4 mt-[34px]'>
          <div>
            <h4 className='text-[16px] leading-[25.6px] font-[600] text-[#1C1F35]'>
              Core Value
            </h4>
          </div>
          <div className='w-full flex flex-col gap-5'>
            <strong className='text-[#182987] text-[16px] leading-[25.6px] font-[600] mb-[6px] whitespace-pre-line break-keep'>
              세일즈를 뛰어넘는 경제의 브릿지
            </strong>
            <ul className='flex flex-col gap-5 leading-[160%] text-[16px] font-medium tracking-[-0.025em]'>
              {coreValues.map((core, index) => {
                return (
                  <li
                    key={`core_${index}`}
                    className='bg-[#F8F8FA] rounded-[10px] p-5 flex flex-col gap-2 tiny:px-4'
                  >
                    <div className='font-semibold'>{core.title}</div>
                    <div className='tracking-[-0.04em] tiny:text-[15px]'>
                      {core.desc}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CISection;
